import { toSignificantFigures } from 'components/Quantity/helpers'
import { FormatterOption } from 'contexts/QuantityFormatting/types'
import { Asset } from 'types/Asset'
import { assertNever } from 'types/assertNever'

import { compactFormatter as compactFormatterBase } from './compact'

export type FormatterFnOpts = {
  precision: number | null
  significantFigures: boolean
}

export const defaultFormatterFnOpts = {
  precision: 8,
  significantFigures: false,
}

export type FormatterFn = (
  quantity: Big,
  currency: Asset | undefined,
  opts: FormatterFnOpts,
) => React.ReactNode

export const fullFormatter: FormatterFn = (
  n,
  _,
  { precision, significantFigures },
) =>
  significantFigures
    ? toSignificantFigures(n, precision ?? defaultFormatterFnOpts.precision)
    : n.round(precision ?? defaultFormatterFnOpts.precision).toFixed()

export const compactFormatter: FormatterFn = (n, currency) =>
  compactFormatterBase(n, currency?.ticker === 'USD' ? 'USD' : undefined)

export const millionsFormatter: FormatterFn = (n, _, { precision }) =>
  toSignificantFigures(
    n.div(1e6),
    precision ?? defaultFormatterFnOpts.precision,
  )

export const thousandsFormatter: FormatterFn = (n, _, { precision }) =>
  toSignificantFigures(
    n.div(1e3),
    precision ?? defaultFormatterFnOpts.precision,
  )

export const allBuiltinFormatters = [
  fullFormatter,
  compactFormatter,
  millionsFormatter,
  thousandsFormatter,
]

export const getFormatter = (formatterOption: FormatterOption): FormatterFn => {
  switch (formatterOption) {
    case 'Full':
      return fullFormatter
    case 'Compact':
      return compactFormatter
    case 'Millions':
      return millionsFormatter
    case 'Thousands':
      return thousandsFormatter
    default:
      return assertNever(formatterOption)
  }
}
